import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=006e39ee&scoped=true&"
import script from "./how-it-works.vue?vue&type=script&lang=ts&"
export * from "./how-it-works.vue?vue&type=script&lang=ts&"
import style0 from "./how-it-works.vue?vue&type=style&index=0&id=006e39ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e39ee",
  null
  
)

export default component.exports